import React, { useState } from "react";
import "./BioDisplay.css";

const BIO_SECTIONS = [
  { key: "bioIntro", label: "Introduction" },
  { key: "bioExperience", label: "Experience" },
  { key: "bioQualifications", label: "Qualifications" },
  { key: "bioTeachingApproach", label: "Teaching Approach" },
];

// Long-bio threshold (combined character count) before we clamp + show "Read more"
const READ_MORE_THRESHOLD = 420;

const BioDisplay = ({ provider, enableReadMore = false }) => {
  const [expanded, setExpanded] = useState(false);

  const sections = BIO_SECTIONS.map((section) => ({
    ...section,
    content: provider?.[section.key]?.trim() || "",
  })).filter((section) => section.content);

  // Legacy fallback: profiles saved before the structured bio fields existed
  // only have a single `about`/`bio` blob — show it under "Introduction"
  // until the tutor re-saves their bio in the new format.
  if (sections.length === 0) {
    const legacyBio = (provider?.about || provider?.bio || "").trim();
    if (legacyBio) {
      sections.push({
        key: "legacy",
        label: "Introduction",
        content: legacyBio,
      });
    }
  }

  if (sections.length === 0) {
    return <p className="no-data">No bio available yet.</p>;
  }

  const totalLength = sections.reduce((sum, s) => sum + s.content.length, 0);
  const isLong = enableReadMore && totalLength > READ_MORE_THRESHOLD;
  const isClamped = isLong && !expanded;

  return (
    <div className="bio-display">
      {sections.map((section) => (
        <div className="bio-section" key={section.key}>
          <h4 className="bio-section-title">{section.label}</h4>
          <p className={`bio-section-text ${isClamped ? "clamped" : ""}`}>
            {section.content}
          </p>
        </div>
      ))}

      {isLong && (
        <button
          type="button"
          className="bio-read-more-btn"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  );
};

export default BioDisplay;
